import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Code2, GitMerge, Mailbox } from 'lucide-react';
const skills = [{
  icon: Mailbox,
  title: 'Support Triage',
  trigger: 'On new Zendesk ticket',
  action: 'Categorize, draft response based on docs, assign to team.',
  code: `skill.on('zendesk.ticket', async (t) => {
  const category = await ai.classify(t.body);
  const draft = await ai.draftReply(t.body);
  return { category, draft };
});`
}, {
  icon: GitMerge,
  title: 'PR Summarizer',
  trigger: 'On GitHub PR open',
  action: 'Read diff, check against Jira, post summary comment.',
  code: `skill.on('github.pr', async (pr) => {
  const diff = await getDiff(pr);
  const summary = await ai.summarize(diff);
  await github.comment(pr.id, summary);
});`
}, {
  icon: Code2,
  title: 'Custom Webhook',
  trigger: 'On HTTP POST',
  action: 'Extract payload, query memory graph, return JSON.',
  code: `skill.on('webhook', async (req) => {
  const context = await memory.query(req.q);
  const result = await ai.extract(context);
  return Response.json(result);
});`
}];
export function Skills() {
  return <section className="py-24 relative" id="skills" data-id="element-269">
      <div className="max-w-6xl mx-auto px-6" data-id="element-270">
        <div className="mb-16 md:flex items-end justify-between" data-id="element-271">
          <div className="max-w-2xl" data-id="element-272">
            <h2 className="font-serif text-4xl md:text-5xl mb-4 text-cozy-text" data-id="element-273">
              Turn queries into Skills.
            </h2>
            <p className="text-cozy-muted text-lg" data-id="element-274">
              Stop doing the same work twice. Convert any natural language query
              or workflow into an automated, reusable Skill with a few lines of
              code.
            </p>
          </div>
          <a href="#" className="hidden md:inline-flex items-center gap-2 text-cozy-accent font-medium hover:text-cozy-accentHover transition-colors" data-id="element-275">
            View Skill Library <ArrowRight className="w-4 h-4" data-id="element-276" />
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-277">
          {skills.map((skill, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white border border-cozy-border rounded-2xl overflow-hidden group hover:shadow-lg hover:shadow-black/5 transition-all" data-id="element-278">
              <div className="p-6 border-b border-cozy-border" data-id="element-279">
                <div className="w-10 h-10 rounded-lg bg-cozy-bg border border-cozy-border flex items-center justify-center mb-4 group-hover:scale-110 transition-transform" data-id="element-280">
                  <skill.icon className="w-5 h-5 text-cozy-text" data-id="element-281" />
                </div>
                <h3 className="text-lg font-medium text-cozy-text mb-1" data-id="element-282">
                  {skill.title}
                </h3>
                <div className="text-xs font-medium text-cozy-accent mb-3" data-id="element-283">
                  {skill.trigger}
                </div>
                <p className="text-sm text-cozy-muted" data-id="element-284">{skill.action}</p>
              </div>
              <div className="bg-[#0A0A0A] p-4 text-xs font-mono text-gray-300 overflow-x-auto" data-id="element-285">
                <pre data-id="element-286">
                  <code data-id="element-287">{skill.code}</code>
                </pre>
              </div>
            </motion.div>)}
        </div>

        <a href="#" className="mt-8 inline-flex md:hidden items-center gap-2 text-cozy-accent font-medium hover:text-cozy-accentHover transition-colors" data-id="element-288">
          View Skill Library <ArrowRight className="w-4 h-4" data-id="element-289" />
        </a>
      </div>
    </section>;
}